/**
 * Read-only Loader der Termine-Sektion (SP6).
 *
 * Liest ausschließlich die UserPreference-Scopes `profile.schedule.twv` /
 * `profile.schedule.systemcheck` über den bestehenden `GET /user-preference`
 * (E1, migrationsfrei). Es gibt bewusst KEIN Save-Pendant in SP6: die Termine-
 * Sektion ist disabled und schreibt nie (E6). `saveUserPreference` existiert,
 * wird hier aber absichtlich nicht importiert.
 *
 * Fehlertoleranz: jeder Loader gibt bei fehlendem Key, 404 (Scope nie
 * geschrieben — Normalfall) oder Fetch-Fehler ein leeres Objekt zurück. Default
 * LEER (E6) — niemals PFLICHT_BLOCK_DEFS-Zeiten o. Ä. als Default.
 */
import {
  fetchUserPreference,
  getCurrentUserPreferenceKey,
} from "../../utils/userPreferences";
import {
  SCOPE_SYSTEMCHECK,
  SCOPE_TWV,
  type SystemcheckSchedule,
  type TwvSchedule,
} from "./scheduleTypes";

/** Liest `profile.schedule.twv`; kein Key / 404 / Fehler → leeres Objekt (Default LEER, E6). */
export async function loadTwvSchedule(): Promise<TwvSchedule> {
  try {
    const key = await getCurrentUserPreferenceKey();
    if (!key) return {};
    const value = await fetchUserPreference<TwvSchedule>(key, SCOPE_TWV);
    return value ?? {};
  } catch {
    return {};
  }
}

/** Liest `profile.schedule.systemcheck`; kein Key / 404 / Fehler → leeres Objekt (Default LEER). */
export async function loadSystemcheckSchedule(): Promise<SystemcheckSchedule> {
  try {
    const key = await getCurrentUserPreferenceKey();
    if (!key) return {};
    const value = await fetchUserPreference<SystemcheckSchedule>(key, SCOPE_SYSTEMCHECK);
    return value ?? {};
  } catch {
    return {};
  }
}
